import React from 'react';
import { useProfileDetails } from '../hooks/use-profile-details.js';
import ProfileDetailsPageView from './profile-details-page-view.jsx';

function ProfileDetailsPageContainer() {
  const state = useProfileDetails();
  return <ProfileDetailsPageView {...state} />;
}

export default ProfileDetailsPageContainer;
